// extracted by mini-css-extract-plugin
export default {"checkoutPage":"Checkout_checkoutPage__YwtfD","checkoutBox":"Checkout_checkoutBox__MEzJd","navLink":"Checkout_navLink__iXcxz"};